/* DermaShine — rebrand home
   Carosello recensioni + lightbox media.
   Progressive enhancement: senza JS la riga resta un overflow-x:auto scorrevole
   a dito e le frecce restano nascoste (niente bottoni morti). */
(function () {
  'use strict';

  function initRecensioni(root) {
    var row = root.querySelector('[data-ds-revrow]');
    if (!row || row.dataset.dsInit === '1') return;
    row.dataset.dsInit = '1';

    var arrows = root.querySelector('[data-ds-arrows]');
    var prev = root.querySelector('[data-ds-prev]');
    var next = root.querySelector('[data-ds-next]');

    function step() {
      var card = row.querySelector('.ds-rcard');
      return card ? card.offsetWidth + 14 : 300;
    }
    function scrollBy(dir) {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      row.scrollBy({ left: dir * step() * 2, behavior: reduce ? 'auto' : 'smooth' });
    }

    if (arrows && prev && next) {
      arrows.hidden = false;
      prev.addEventListener('click', function () { scrollBy(-1); });
      next.addEventListener('click', function () { scrollBy(1); });

      var sync = function () {
        var max = row.scrollWidth - row.clientWidth - 2;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= max;
        prev.style.opacity = prev.disabled ? '.4' : '';
        next.style.opacity = next.disabled ? '.4' : '';
      };
      row.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }

    /* Qui c'era la lightbox delle recensioni: cercava [data-ds-lightbox],
       [data-ds-lbclose] e .ds-rmedia, che nessuna sezione ha mai stampato.
       Rimossa il 07/09/2026 con le sue regole in ds-rebrand.css. */
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-ds-recensioni]');
    for (var i = 0; i < roots.length; i++) initRecensioni(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // ricarica della sezione dal Personalizza tema
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

/* ============================================================================
   VETRINA D'ACQUISTO
   Galleria, selettore bundle, bounce del pulsante, nastro video dei creator.
   La logica del bundle e' la stessa gia' in produzione sulla pagina prodotto
   PageFly (dermashine-pagefly-generatore/ds_bundle.py): le cifre non sono
   scritte qui, arrivano dallo schema via data-attribute.
   ============================================================================ */
(function () {
  'use strict';

  var euro = function (cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  };
  var lista = function (sel, dove) {
    return Array.prototype.slice.call((dove || document).querySelectorAll(sel));
  };

  /* ---------------------------------------------------------------- galleria */
  function initGalleria(root) {
    var gal = root.querySelector('[data-ds-gal]');
    if (!gal || gal.dataset.dsInit === '1') return;
    gal.dataset.dsInit = '1';

    var main = gal.querySelector('[data-ds-gal-main]');
    var thumbs = lista('[data-ds-gal-th]', gal);
    if (!main || !thumbs.length) return;

    function scegli(th) {
      var src = th.dataset.full;
      if (!src || main.getAttribute('src') === src) return;
      var box = main.parentNode;
      box.classList.add('is-loading');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        main.setAttribute('src', src);
        if (th.dataset.alt) main.setAttribute('alt', th.dataset.alt);
        box.classList.remove('is-loading');
      };
      pre.src = src;
      thumbs.forEach(function (x) {
        x.classList.toggle('is-sel', x === th);
        x.setAttribute('aria-selected', x === th ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (th) {
      th.addEventListener('click', function () { scegli(th); });
      // stesso schema di tastiera della pagina prodotto: Invio e Spazio
      th.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
          e.preventDefault();
          scegli(th);
        }
      });
    });
  }

  /* ------------------------------------------------------------------ bundle */
  function initBundle(root) {
    var box = root.querySelector('[data-ds-bundle]');
    if (!box || box.dataset.dsInit === '1') return;
    box.dataset.dsInit = '1';

    var PK = {};
    try { PK = JSON.parse(box.dataset.pacchetti || '{}'); } catch (e) { return; }
    var handle = box.dataset.handle;
    /* `ebookHandle` stava qui e serviva solo all'acquisto, che ora non c'e' piu'.
       L'attributo data-ebook-handle resta sul markup: non e' il momento di
       toccare il Liquid della sezione per una cosa che non si vede. */
    var listino = parseInt(box.dataset.listino, 10) || 0;
    var scelto = parseInt(box.dataset.predefinito || '2', 10);

    var vTot = box.querySelector('[data-ds-tot]');
    var vOld = box.querySelector('[data-ds-tot-old]');
    var vSave = box.querySelector('[data-ds-tot-save]');

    function aggiorna() {
      var p = PK[scelto] || PK[2];
      if (!p) return;
      var pieno = listino * p.q;
      var risp = pieno - p.tot;
      if (vTot) vTot.textContent = euro(p.tot);
      if (vOld) { vOld.textContent = euro(pieno); vOld.style.display = risp > 0 ? '' : 'none'; }
      if (vSave) {
        vSave.textContent = 'Risparmi ' + euro(risp);
        vSave.classList.toggle('is-off', risp <= 0);
      }
      lista('.ds-pk', box).forEach(function (l) {
        var q = parseInt(l.dataset.pk, 10);
        l.classList.toggle('is-sel', q === scelto);
        var pk = PK[q];
        if (!pk) return;
        var old = l.querySelector('[data-old]');
        var each = l.querySelector('[data-each]');
        if (old) old.textContent = euro(listino * pk.q);
        if (each) each.textContent = euro(Math.round(pk.tot / pk.q)) + ' al pezzo';
      });
    }

    lista('.ds-pk-in', box).forEach(function (r) {
      r.addEventListener('change', function () {
        scelto = parseInt(r.value, 10);
        aggiorna();
      });
    });

    // il barrato non si inventa: il listino vero arriva da Shopify a ogni caricamento
    if (handle) {
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (d) { if (d && d.price) { listino = d.price; aggiorna(); } })
        .catch(function () {});
    }
    aggiorna();

    /* Qui c'era l'acquisto della home: cercava [data-ds-buynow], svuotava il
       carrello, aggiungeva i pezzi piu' l'ebook e andava a
       /checkout?discount=BUNDLE2|BUNDLE3.
       Rimosso il 07/09/2026 insieme al bottone che lo azionava
       (sections/ds-dispositivo.liquid, ora un link alla pagina prodotto):
       i pacchetti sono varianti vere e si comprano solo da li'.
       Era anche l'ultimo `?discount=` rimasto nel tema.
       Quello che sta sopra — card, radio e totale — continua a girare. */
  }

  /* ------------------------------------------------------------------ bounce */
  function initBounce(root) {
    if (!('IntersectionObserver' in window)) return;
    lista('.ds-bounce', root).forEach(function (b) {
      if (b.dataset.dsBounce === '1') return;
      b.dataset.dsBounce = '1';
      new IntersectionObserver(function (voci) {
        voci.forEach(function (v) { b.classList.toggle('is-paused', !v.isIntersecting); });
      }, { threshold: 0.2 }).observe(b);
    });
  }

  /* ----------------------------------------------- nastro video dei creator */
  function initUgc(root) {
    var video = lista('[data-ds-ugc] video', root);
    if (!video.length) return;
    var ridotto = window.matchMedia
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!('IntersectionObserver' in window) || ridotto) return;

    var osservatore = new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        var el = v.target;
        if (v.isIntersecting) {
          var pr = el.play();
          if (pr && pr.catch) pr.catch(function () {});
        } else if (!el.paused) {
          el.pause();
        }
      });
    }, { threshold: 0.25 });

    video.forEach(function (v) {
      if (v.dataset.dsInit === '1') return;
      v.dataset.dsInit = '1';
      v.pause();
      osservatore.observe(v);
    });
  }

  function avvia(scope) {
    var s = scope || document;
    initGalleria(s);
    initBundle(s);
    initBounce(s);
    initUgc(s);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { avvia(); });
  } else {
    avvia();
  }
  document.addEventListener('shopify:section:load', function (e) { avvia(e.target); });
})();

/* DermaShine — header della home.
   Tre cose che sulla home mancavano perche' sections/header.liquid non gira:
   il contatore del carrello, il carrello a tendina e il menu mobile.
   Gira SOLO dove c'e' [data-ds-header], cioe' sulla home: sulle altre pagine
   comanda l'header di Impulse e questo blocco non tocca niente.
   Tutto in progressive enhancement: senza JS l'icona resta un link a /cart e
   il pannello del menu non compare (parte con hidden). */
(function () {
  'use strict';

  var header = null;

  /* ------------------------------------------------------ contatore carrello */

  function scriviConteggio(n) {
    if (!header) return;
    var link = header.querySelector('[data-ds-cart]');
    var badge = header.querySelector('[data-ds-cart-n]');
    if (!link || !badge) return;

    n = Number(n);
    if (!isFinite(n) || n < 0) n = 0;

    badge.textContent = n > 99 ? '99+' : String(n);
    badge.hidden = n === 0;

    /* Le etichette arrivano dal Liquid via data-attribute: cosi' le stringhe
       restano tradotte nel tema e non finiscono scritte a mano qui dentro. */
    var lab = n === 0 ? link.getAttribute('data-lab-0')
            : n === 1 ? link.getAttribute('data-lab-1')
            : (link.getAttribute('data-lab-n') || '').replace('[n]', n);
    if (lab) link.setAttribute('aria-label', lab);
  }

  function leggiCarrello() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) scriviConteggio(c.item_count); })
      .catch(function () {});
  }

  /* I due eventi li emette Impulse con jQuery: un listener nativo non li
     sentirebbe, quindi qui jQuery serve davvero. Le stringhe sono identiche
     a quelle che il tema triggera (theme.js: 'updateCart.ajaxcart' e
     'added.ajaxProduct'), per non dipendere da come jQuery risolve i namespace. */
  function agganciaEventi() {
    var $ = window.jQuery || (window.theme && window.theme.jQuery);
    if (!$) return false;

    $('body').on('updateCart.ajaxcart', function (e, cart) {
      if (cart && typeof cart.item_count !== 'undefined') scriviConteggio(cart.item_count);
      else leggiCarrello();
    });

    // rete di sicurezza se il carrello non e' a tendina: li' updateCart non arriva
    $('body').on('added.ajaxProduct', function () { leggiCarrello(); });

    return true;
  }

  /* ------------------------------------------------------ carrello a tendina */

  /* theme.CartDrawer viene istanziato da HeaderSection (theme.js, initDrawers),
     registrata su data-section-type="header-section": sulla home quella sezione
     non c'e', quindi il drawer non nascerebbe mai. Lo istanziamo noi, ma solo
     se c'e' davvero tutto. Se manca un pezzo non si istanzia e non esplode
     niente: l'icona resta un link normale a /cart. */
  function provaDrawer() {
    if (window.__dsCartDrawer) return true;
    if (!window.theme || !window.theme.settings) return false;      // theme.js non pronto
    if (window.theme.settings.cartType !== 'drawer') return true;   // carrello a pagina: finito
    if (!document.getElementById('CartDrawer')) return true;        // niente markup: finito
    if (typeof window.theme.CartDrawer !== 'function') return false;
    if (!window.jQuery || typeof window.Handlebars === 'undefined') return false;
    if (!document.getElementById('CartTemplate')) return true;      // senza template Handlebars esplode

    try {
      window.__dsCartDrawer = new window.theme.CartDrawer();
    } catch (e) {
      window.__dsCartDrawer = true;                                 // non riprovare all'infinito
    }
    return true;
  }

  /* ------------------------------------------------------------ menu mobile */

  function focusabili(el) {
    var sel = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
    return Array.prototype.filter.call(el.querySelectorAll(sel), function (n) {
      return n.offsetParent !== null || n.getClientRects().length > 0;
    });
  }

  function initMenu() {
    var burger = header.querySelector('[data-ds-burger]');
    var panel = header.querySelector('[data-ds-menu]');
    if (!burger || !panel) return;

    var aperto = false;

    /* Il bottone entra nel giro del focus: e' anche il comando di chiusura,
       quindi chi naviga da tastiera deve poterci tornare senza uscire. */
    function giro() { return [burger].concat(focusabili(panel)); }

    function onKey(e) {
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); chiudi(true); return; }
      if (e.key !== 'Tab') return;

      var voci = giro();
      if (!voci.length) return;
      var primo = voci[0];
      var ultimo = voci[voci.length - 1];

      if (voci.indexOf(document.activeElement) === -1) { e.preventDefault(); primo.focus(); return; }
      if (e.shiftKey && document.activeElement === primo) { e.preventDefault(); ultimo.focus(); }
      else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primo.focus(); }
    }

    function onFuori(e) { if (!header.contains(e.target)) chiudi(false); }

    function apri() {
      if (aperto) return;
      aperto = true;
      panel.hidden = false;
      burger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('ds-menu-aperto');
      var f = focusabili(panel);
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKey, true);
      document.addEventListener('click', onFuori, true);
    }

    function chiudi(ridaiFuoco) {
      if (!aperto) return;
      aperto = false;
      panel.hidden = true;
      burger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('ds-menu-aperto');
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('click', onFuori, true);
      if (ridaiFuoco) burger.focus();
    }

    burger.addEventListener('click', function () { if (aperto) chiudi(true); else apri(); });

    /* Le voci sono ancore nella stessa pagina: chiudo subito e NON faccio
       preventDefault, cosi' il browser salta con l'header gia' tornato a 74px
       e scroll-margin-top resta tarato giusto. */
    panel.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('a')) chiudi(false);
    });

    // tornati in desktop il pannello non ha piu' senso: il CSS nasconde il bottone
    if (window.matchMedia) {
      var mq = window.matchMedia('(min-width: 901px)');
      var cambio = function (ev) { if (ev.matches) chiudi(false); };
      if (mq.addEventListener) mq.addEventListener('change', cambio);
      else if (mq.addListener) mq.addListener(cambio);
    }
  }

  /* ------------------------------------------------------------------ avvio */

  var fattoEventi = false;
  var fattoDrawer = false;

  function tenta() {
    if (!fattoEventi) fattoEventi = agganciaEventi();
    if (!fattoDrawer) fattoDrawer = provaDrawer();
    return fattoEventi && fattoDrawer;
  }

  function avviaHeader() {
    if (window.__dsHeaderInit) return;
    header = document.querySelector('[data-ds-header]');
    if (!header) return;                       // non e' la home: non tocchiamo niente
    window.__dsHeaderInit = true;

    initMenu();

    /* ds-rebrand.js e theme.js sono due defer nel <head> e ds-rebrand viene
       prima: qui theme.js potrebbe non aver ancora girato. Si prova subito e
       poi si insiste per un po', poi si molla in silenzio. */
    if (tenta()) return;
    var giri = 0;
    var t = setInterval(function () {
      giri++;
      if (tenta() || giri > 100) clearInterval(t);   // ~6 secondi e basta
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avviaHeader);
  } else {
    avviaHeader();
  }

  // ritorno indietro da bfcache: il numero stampato dal server puo' essere vecchio
  window.addEventListener('pageshow', function (e) { if (e.persisted) leggiCarrello(); });

  /* Ricarica della sezione dal Personalizza tema: il markup dell'header e' nuovo,
     quindi il menu va ricablato. Gli agganci del contatore stanno su <body> e
     restano validi, il drawer e' gia' istanziato e non va rifatto. */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target;
    if (!t || !t.querySelector) return;
    if (!t.querySelector('[data-ds-header]')) return;
    header = document.querySelector('[data-ds-header]');
    if (header) initMenu();
  });
})();

/* DermaShine — «Acquista ora» della pagina prodotto, 07/09/2026.

   PRIMA: il bottone svuotava il carrello, ci metteva N pezzi della variante
   unica piu' l'ebook a listino, e andava a /checkout?discount=BUNDLE2|BUNDLE3.
   Il prezzo del pacchetto esisteva solo grazie al codice sconto, quindi bastava
   che il cliente toccasse il carrello per perderlo e pagare a prezzo pieno.

   ADESSO: i pacchetti sono VARIANTI vere (opzione "Confezione" sul prodotto
   9606548455754, create il 07/09/2026) e il prezzo sta sulla variante. Il
   bottone porta al permalink del carrello con la variante scelta e l'ebook
   accanto. Nessun codice sconto, in nessuna forma: l'ebook lo azzera lo sconto
   automatico «Ebook in omaggio con 2 o 3 pezzi». */
(function () {
  'use strict';

  /* Mappa card -> variante. La chiave e' il `value` del radio .ds-pk-in, che e'
     lo stesso numero del `data-pk` sulla card.
       1 pezzo  -> 49691705573706   34,95  (barrato 79,99)
       2 pezzi  -> 63453327950154   59,90  (barrato 69,90)
       3 pezzi  -> 63453327982922   79,90  (barrato 104,85)
     Volutamente scritta qui e non ricavata a runtime: al click non deve esserci
     nessuna fetch di mezzo, altrimenti si introduce un'attesa e un modo di
     fallire proprio sul bottone che incassa. Se le varianti cambiano in
     Shopify, si aggiornano queste tre righe. */
  var VARIANTE = {
    '1': '49691705573706',
    '2': '63453327950154',
    '3': '63453327982922'
  };

  function soloCifre(v) { return typeof v === 'string' && /^[0-9]+$/.test(v); }

  /* Quale pacchetto e' selezionato.
     La dichiarazione vive nel template PageFly, che non si tocca: le card sono
     <label class="ds-pk" data-pk="1|2|3"> e dentro ognuna c'e' un
     <input class="ds-pk-in" type="radio" name="ds-pack" value="1|2|3">.
     La verita' e' il radio :checked, perche' e' lo stesso stato su cui si basa
     lo script di PageFly. La classe .is-sel sulla card e' la stessa
     informazione riscritta, e la uso solo come rete di sicurezza. */
  function pacchettoScelto(box) {
    var radio = box.querySelector('.ds-pk-in:checked');
    if (radio && VARIANTE[radio.value]) return radio.value;

    var card = box.querySelector('.ds-pk.is-sel');
    var pk = card && card.getAttribute('data-pk');
    if (pk && VARIANTE[pk]) return pk;

    return null;
  }

  /* Il click si prende in CATTURA su document, cioe' prima che arrivi al
     bottone. Serve perche' il template PageFly attacca un suo gestore sullo
     stesso bottone, e quel file non si puo' modificare: qui lo si scavalca.
     stopImmediatePropagation ferma l'evento prima del bersaglio, quindi il
     gestore di PageFly non parte proprio — e non c'e' modo che i due si
     rincorrano a colpi di redirect.
     La cattura vince a prescindere dall'ordine di registrazione: non dipende
     dal fatto che ds-rebrand.js sia defer e PageFly inline. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var btn = t.closest('.ds-buynow');
    if (!btn) return;

    /* Fuori dalla pagina prodotto non c'e' nessun #ds-bund: in quel caso non
       tocco niente e lascio passare il click com'era. */
    var box = document.getElementById('ds-bund');
    if (!box) return;

    var pk = pacchettoScelto(box);
    if (!pk) return;   /* non so cosa ha scelto: meglio lasciar fare che tirare a indovinare */

    e.preventDefault();
    e.stopImmediatePropagation();

    var pezzi = [VARIANTE[pk] + ':1'];

    /* L'id dell'ebook e' quello che il Liquid stampa su #ds-bund come
       data-ebook, ed e' lo stesso che il codice di prima usava per metterlo nel
       carrello. Non si inventa e non si cerca altrove.
       Se mancasse, si va avanti col solo dispositivo: meglio vendere senza
       omaggio che bloccare l'acquisto. */
    var ebook = box.getAttribute('data-ebook');
    if (pk !== '1' && soloCifre(ebook)) pezzi.push(ebook + ':1');

    btn.disabled = true;   /* solo contro il doppio click: qui sotto si naviga subito */

    window.location.href = '/cart/' + pezzi.join(',');
  }, true);
})();
